import React, { Component } from 'react';
import axios from 'axios';
import { Link, type RouteComponentProps } from 'react-router-dom';
import store from '../../store/store';
import * as helper from '../../helper/index';
import { toastr } from 'react-redux-toastr';
import { classes } from './login';

interface userprops extends RouteComponentProps {}
class Registration extends Component<userprops> {
  state = {
    username: '',
    email: '',
    password: '',
    company: '',
    errorMessage: '',
    user: {},
  };

  componentDidMount() {
    if (store.getState().auth.jwt) {
      this.props.history.push('/dashboard');
    }
  }

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.imagebox}></div>
        <div className={classes.formBox}>
          <div className="flex flex-row h-screen items-center justify-center">
            <div className={classes.formContainer}>
              <div className={classes.heading}>
                <h2>
                  Register to&nbsp;
                  <strong>{(process.env.REACT_APP_COURIER_COMPANY_NAME ?? '').replace(' ', '')}</strong>
                </h2>
                <p className="mb-4 text-danger">{this.state.errorMessage} </p>
              </div>

              <form onSubmit={this.register}>
                <div>
                  <label htmlFor="company" className={classes.label}>
                    Company Name
                  </label>
                  <input
                    type="text"
                    className={classes.input}
                    placeholder="Microsoft"
                    id="company"
                    onChange={(e) => {
                      this.handleChange(e, 'company');
                    }}
                  />
                </div>
                <div className="form-group first">
                  <label htmlFor="username" className={classes.label}>
                    Phone Number / Email
                  </label>
                  <input
                    type="text"
                    className={classes.input}
                    placeholder="01..."
                    id="username"
                    onChange={(e) => {
                      this.handleChange(e, 'username');
                    }}
                  />
                </div>
                <div className="form-group first">
                  <label htmlFor="email" className={classes.label}>
                    Email
                  </label>
                  <input
                    type="text"
                    className={classes.input}
                    placeholder="your-email@gmail.com"
                    id="email"
                    onChange={(e) => {
                      this.handleChange(e, 'email');
                    }}
                  />
                </div>
                <div className="form-group last mb-3">
                  <label htmlFor="password" className={classes.label}>
                    Password
                  </label>
                  <input
                    type="password"
                    className={classes.input}
                    placeholder="Your Password"
                    id="password"
                    onChange={(e) => {
                      this.handleChange(e, 'password');
                    }}
                  />
                </div>
                <div className="flex flex-nowrap justify-evenly">
                  <div>
                    <span className="m-auto">
                      <Link to="/" className="forgot-pass">
                        Login
                      </Link>
                    </span>
                  </div>
                  <div>
                    <span className="m-auto">
                      <Link to="/forgot-password" className="forgot-pass">
                        Forgot Password
                      </Link>
                    </span>
                  </div>
                </div>
                <input type="submit" value="Register" className={classes.button} />
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    this.setState({ [key]: e.target.value });
  };

  register = async (event: { preventDefault: () => void }) => {
    const that = this;
    event.preventDefault();
    await axios
      .post(`${process.env.REACT_APP_API_SERVER}/auth/local/register`, {
        username: that.state.username,
        email: that.state.email,
        password: that.state.password,
        company_name: that.state.company,
      })
      .then((res) => {
        this.setState({
          user: res.data,
        });
        if (res.data.jwt) {
          that.props.history.push('/dashboard');
          toastr.success('Success', 'Registration successful Please login');
        }
        // if (res.data.user.confirmed == null) {
        //   that.props.history.push("/check-email");
        // }
      })
      .catch((error) => {
        if (error.response) {
          this.setState({
            errorMessage: error.response.data.message[0].messages[0].message,
          });
        }
        if (String(error.response?.status) === '400') {
          const title = `${error.response?.data?.error}`;
          const msg = error?.response?.data?.message?.[0]?.messages?.[0]?.message ?? 'Something went wrong!';
          toastr.error(title, msg);
          return;
        }
        helper.axiosErrorHandling(error);
      });
  };
}

export default Registration;
